import { FullInfoResponse } from 'react-easyrocket';

/** Отдает объект с ключами dataToProfile, а значения
 * заменяет из newFullInfo
 */
export const mergeProfileData = (
  dataToProfile: Record<string, string>,
  newFullInfo: FullInfoResponse | undefined = {} as FullInfoResponse,
  hasDialingCodeField: boolean
) => {
  // * если нет новых данных просто возвращаем существующие
  if (!newFullInfo) return dataToProfile;

  return Object.keys(dataToProfile).reduce((mergedProfile, key) => {
    // * в форме есть dialingCode -> подставляем в него код из номера телефона
    if (hasDialingCodeField && key === 'code') {
      // * Переименовываем поле code -> dialingCode
      mergedProfile['dialingCode'] = dataToProfile.code;
      return mergedProfile;
    }

    // * в форме есть dialingCode -> сохраняем номер телефона как есть
    if (hasDialingCodeField && key === 'phone') {
      mergedProfile[key] = dataToProfile.phone;
      return mergedProfile;
    }

    // * в форме нет dialingCode -> поле code скипаем
    if (!hasDialingCodeField && key === 'code') {
      return mergedProfile;
    }

    // *в форме нет dialingCode но в новых данных есть телефон и код -> соединяем код и телефон в одну строку
    if (
      !hasDialingCodeField &&
      key === 'phone' &&
      newFullInfo.phone?.code &&
      newFullInfo.phone?.number
    ) {
      mergedProfile[key] = `${newFullInfo.phone.code}${newFullInfo.phone.number}`;
      return mergedProfile;
    }

    // * в остальных случаях подставляем новые данные если они есть в newFullInfo, если нет, то просто возврвщаем данные для поля из dataToProfile
    mergedProfile[key] =
      (newFullInfo[key as keyof FullInfoResponse] as string) ?? dataToProfile[key];

    return mergedProfile;
  }, {} as Record<string, string>);
};
